import type { DirectoryPublic } from '@repo/types/directory';
import type { FilePublicWithPermissions } from '@repo/types/files';

import { useCallback, useState } from 'react';

import { useFilesStorage } from '@/store/files-store';

type FSEntityType = 'file' | 'directory';

interface UseEntityMenusProps<T extends FilePublicWithPermissions | DirectoryPublic> {
  entity: T;
  entityType: FSEntityType;
}

export const useEntityMenus = <T extends FilePublicWithPermissions | DirectoryPublic>({ entity, entityType }: UseEntityMenusProps<T>) => {
  const [openDropdownMenu, setOpenDropdownMenu] = useState<boolean>(false);
  const [openContextMenu, setOpenContextMenu] = useState<boolean>(false);
  const { onFSEntityClick } = useFilesStorage();

  const handleOpenDropdownMenu = useCallback(
    (isOpen: boolean) => {
      setOpenDropdownMenu(isOpen);
      if (isOpen) {
        onFSEntityClick({ [entityType]: entity });
      }
    },
    [entity, entityType, onFSEntityClick]
  );

  const handleOpenContextMenu = useCallback(
    (isOpen: boolean) => {
      setOpenContextMenu(isOpen);
      if (isOpen) {
        onFSEntityClick({ [entityType]: entity });
      }
    },
    [entity, entityType, onFSEntityClick]
  );

  return {
    openContextMenu,
    openDropdownMenu,
    handleOpenDropdownMenu,
    handleOpenContextMenu,
  };
};
